// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3tEWxi8m clearfix","list":"list-3b2dF77U"};